// extracted by mini-css-extract-plugin
export default {"mobileMaxWidth":"767px","mobilePanelHeight":"50%","mobileNavbarHeight":"55px","title":"FeatureLayout_title__JAS2A","content":"FeatureLayout_content__-Q2Zi"};